/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import {css} from 'styled-components';
import {darken} from 'polished';
import Colors from '../../constants/Colors';
import {FiraSansBold} from '../Text';


/* function teste(valor = 1){
return valor;
}
teste() == 1
teste(2) == 2 */

const generateStyle = (color, bg, bgFocus, bgActive, args = []) => {
  return css`
  color: ${color};
  background-color: ${bg};
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background-color: ${bgFocus};
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
  }
  &:active:not(:disabled) {
    background-color: ${bgActive};
  }
  ${args.length >= 1 ? args.join('\n') : ''}
  `;
}


const primaryMixin = generateStyle(Colors.WHITE, Colors.BLUE, darken(0.1, Colors.BLUE), darken(0.2, Colors.BLUE));
const secundaryMixin = generateStyle(Colors.WHITE, Colors.GRAY[6], darken(0.1, Colors.GRAY[0]), darken(0.2, Colors.GRAY[3]));
const thirdMixin = generateStyle(Colors.WHITE, Colors.GRAY[6], darken(0.1, Colors.GRAY[0]), darken(0.2, Colors.GRAY[3]));


/* const outlinePrimaryMixin = generateStyle(Colors.WHITE,Colors.GRAY[6], darken(0.1, Colors.GRAY[0]), darken(0.2, Colors.GRAY[3]),
[`border: 1px ${({ dashed }) => (dashed ? 'dashed' : 'solid')} ${Colors.SECONDARY};`,`${FiraSansBold}`])
 */

const outlinePrimaryMixin = css`
border: 1px ${({ dashed }) => (dashed ? 'dashed' : 'solid')} ${Colors.BLUE};
${FiraSansBold}
  color: ${Colors.WHITE};
  padding: 4px 16px;
  text-transform: none;
  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: white;
    border-color: ${Colors.BLUE};
    background: ${Colors.BLUE};
  }
  &:active:not(:disabled) {
    background-color: ${darken(0.2, Colors.BLUE)};
  }
`;

const forthMixin = css`
  padding: 0.75rem 0.95rem;
  color: ${Colors.GRAY[6]};
  max-width: 200px;
`;

const grayTextMixin = css`
  padding: 8px 0;
  color: ${Colors.GRAY[0]};
  &:active:not(:disabled) {
    color: ${Colors.GRAY[3]};
  }
`;

const noBorderPrimaryMixin = css`
  color: ${Colors.BLUE};
  padding: 6px 16px;
  ${FiraSansBold}
  text-transform: none;
  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: ${Colors.PRIMARY};
  }
  &:active:not(:disabled) {
    color: ${Colors.PRIMARY};
  }
`;

// Size mixin
const smallMixin = css`
  height: 32px;
`;

export {
  primaryMixin,
  outlinePrimaryMixin,
  grayTextMixin,
  noBorderPrimaryMixin,
  smallMixin,
  secundaryMixin,
  thirdMixin,
  forthMixin,
};